import React from 'react';
import AnimatedPlaceholderChatroomEntry from './AnimatedPlaceholderChatroomEntry';
var AMOUNT_OF_DUMMY_CHATROOMS = 12;
var AnimatedPlaceholderChatroomList = function () {
    return (React.createElement("div", null, Array(AMOUNT_OF_DUMMY_CHATROOMS)
        .fill(undefined)
        .map(function (_, i) { return (React.createElement(AnimatedPlaceholderChatroomEntry, { key: i })); })));
};
export default AnimatedPlaceholderChatroomList;
//# sourceMappingURL=AnimatedPlaceholderChatroomList.js.map